
import {
  GET_MISSING_UPC_REQUEST,
  GET_MISSING_UPC_SUCCESS,
  GET_MISSING_UPC_ERROR
} from "../actions/types";

export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case GET_MISSING_UPC_REQUEST:
      return {
        loading: true,
      };
    case GET_MISSING_UPC_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_MISSING_UPC_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};